//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { shallowEqual, useSelector } from 'react-redux'

//  ----------------------------------------------------------------------------
//  Selectors
//  ----------------------------------------------------------------------------

//  -- Examples data ------------------
const selector = (state) => state.welcomeVideos;

//  -- Examples array selector --------

export const useWelcomeVideos = () => {
    const selectedData = useSelector(selector, shallowEqual)
    return selectedData;
}

